export const MI = 'MovableInk';
export const MI_IN_BEE_EDITOR = 'MovableInkInBeeEditor';
export const MI_PREVIEW_KEY = 'MovableInk';
